import styled from "styled-components/macro"

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 28px;
  padding: 0;
`
